import { useState } from "react";
import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

export default function FieldText({
  label,
  value,
  onChange,
  placeholder,
  type,
  hint,
  suffix,
  icon,
  reveal,
  disabled,
  required,
  error,
  min,
  max,
  step,
  id,
}) {
  const [shown, setShown] = useState(false);
  // password fields can opt into an eye toggle that swaps to a text input
  const canReveal = reveal && type === "password";
  const effectiveType = canReveal && shown ? "text" : type;
  const hasWrap = icon || suffix || canReveal;
  const padRight = (suffix && 46) || (canReveal && 42) || null;
  const inputStyle = {
    ...(padRight ? { paddingRight: padRight } : null),
    ...(error ? { borderColor: "var(--danger)" } : null),
  };
  const input = (
    <input
      id={id}
      className="rec-input"
      type={effectiveType}
      value={value ?? ""}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      min={min}
      max={max}
      step={step}
      onChange={(e) => onChange?.(e.target.value)}
      onWheel={type === "number" ? (e) => e.target.blur() : undefined}
      style={inputStyle}
    />
  );
  return (
    <div className="rec-field">
      {label && <label htmlFor={id}>{label}</label>}
      {hasWrap ? (
        <div className="rec-input-wrap">
          {icon && <Icon name={icon} />}
          {input}
          {suffix && (
            <span className="absolute right-3 text-[12.5px] font-semibold text-ink-3">
              {suffix}
            </span>
          )}
          {canReveal && (
            <button
              type="button"
              tabIndex={-1}
              className="absolute right-[6px] w-[30px] h-[30px] flex items-center justify-center bg-transparent border-0 cursor-pointer text-ink-3 hover:text-ink"
              onClick={() => setShown((s) => !s)}
              aria-label={shown ? "Hide password" : "Show password"}
            >
              <Icon name={shown ? "visibility_off" : "visibility"} style={{ fontSize: 19 }} />
            </button>
          )}
        </div>
      ) : (
        input
      )}
      {hint && <small>{hint}</small>}
    </div>
  );
}

FieldText.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  hint: PropTypes.node,
  suffix: PropTypes.node,
  icon: PropTypes.string,
  reveal: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
};

FieldText.defaultProps = {
  label: null,
  value: "",
  onChange: undefined,
  placeholder: undefined,
  type: "text",
  hint: null,
  suffix: null,
  icon: undefined,
  reveal: false,
  disabled: false,
  required: false,
  error: false,
  min: undefined,
  max: undefined,
  step: undefined,
  id: undefined,
};
